import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { ISpacing, mergeStyleSets } from "@fluentui/react/lib/Styling";

import { EntityType } from "Model/EntityType";
import {
  flex, flexGap, flexHorizontal, flexItem, textOverflow
} from "Utils/Styles";

const classNames = {
  card: `MissingFieldsEntryCard`,
  cardName: `MissingFieldsEntryCardName`,
  cardFields: `MissingFieldsEntryCardFields`,
  entry: `MissingFieldsEntryEntry`,
  icon: `MissingFieldsEntryIcon`,
  label: `MissingFieldsEntryLabel`,
  root: `MissingFieldsEntryRoot`
};

export function useMissingFieldsEntryStyles(type: EntityType, index: number) {
  const { semanticColors, spacing } = useTheme();
  return useMemo(
    () => mergeStyleSets({
      root: [
        classNames.root,
        {
          cursor: `pointer`,
          marginLeft: getEntityMargin(type, spacing),
          padding: `6px 4px`,
          marginTop: type === EntityType.Project && index > 0 ? spacing.m : `initial`,
          "&:hover": {
            backgroundColor: semanticColors.listItemBackgroundHovered
          }
        }
      ],
      entry: [
        classNames.entry,
        {
          ...flexHorizontal,
          ...flexGap(spacing.m)
        }
      ],
      icon: [classNames.icon, { ...flexItem }],
      label: [
        classNames.label,
        {
          ...flexItem,
          ...textOverflow
        }
      ],
      card: [
        classNames.card,
        {
          ...flex,
          ...flexGap(spacing.s1),
          width: `480px`,
          minHeight: `100px`,
          padding: spacing.m,
          border: 0
        }
      ],
      cardName: [classNames.cardName, { ...flexItem }],
      cardFields: [classNames.cardFields, { ...flexItem }]
    }),
    [index, semanticColors, spacing, type]
  );
}

function getEntityMargin(type: EntityType, spacing: ISpacing): string {
  if (type === EntityType.Contact) {
    return spacing.l2;
  }

  if (type === EntityType.Company) {
    return spacing.m;
  }

  return `0px`;
}
